import { createAction } from 'redux-actions';

export const NAMES = {
  UPDATE_SEARCH: 'CLIENT.SEARCH.UPDATE_SEARCH',
  RESET_SEARCH: 'CLIENT.SEARCH.RESET_SEARCH',
};

export const updateSearch = createAction(NAMES.UPDATE_SEARCH);
export const resetSearch = createAction(NAMES.RESET_SEARCH);



// WEBPACK FOOTER //
// ./src/widget/redux/client/actions/search.js